import React, { Component } from 'react';
import { apiServices } from '../../services/apiServices';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Accordion, Card, Badge, Row, Col } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import CaseDetails from '../inbox/CaseDetails';
import Loader from '../../components/loaders/loader';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import { compose, withProps, withHandlers } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer";

import Spiderfy from './Spiderfy';

const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

const MapWithAMarkerClusterer = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAQw9CocoHxqErBbM-GwMQxxFJ5AGLKpBQ&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `545px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withHandlers({
        onMarkerClustererClick: () => (markerClusterer) => {
            const clickedMarkers = markerClusterer.getMarkers();
            console.log(`Current clicked markers length: ${clickedMarkers.length}`)
            console.log(clickedMarkers)
        },
    }),
    withScriptjs,
    withGoogleMap
)(props =>
    <GoogleMap
    defaultZoom={5}
    defaultCenter={{ lat: parseFloat(props.markers[0].latitude), lng: parseFloat(props.markers[0].longitude) }}
  >
    <MarkerClusterer
      onClick={props.onMarkerClustererClick}
      averageCenter
      enableRetinaIcons
      gridSize={60}
      minimumClusterSize={10}
    >
        <Spiderfy>
            {props.markers.map((marker,index) => {
                // console.log("marker",marker);
                return <Marker
                key={index}
                position={{ lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) }}
                onClick={()=> props.onMarkerClick(marker)}
                zIndex={index}
                />
            })}
        </Spiderfy>
    </MarkerClusterer>
  </GoogleMap>
);

const EmptyMap = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAQw9CocoHxqErBbM-GwMQxxFJ5AGLKpBQ&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `545px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(props => (
    <GoogleMap defaultZoom={3} defaultCenter={{ lat: 19.1915493, lng: 72.9549184 }} />
));

export class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            selectedData: {},
            types: this.props.types,
            isLoading: false,
            tableData: [],
            mapData: [],
            latitude: '',
            longitude: '',
            activeTab: 'map',
            sUUID: '',
            isDataFetched: false,
            countryList: [],
            serviceList: [],
            chatHistory: [],
        };
        this.toggle = this.toggle.bind(this);
    }
    componentDidMount() {
        this.getAnalyticsData();
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    getAnalyticsData = async () => {
        this.setState({ isLoading: true });
        let oCoummunity = JSON.parse(localStorage.getItem('community')).community,
            sUUID = oCoummunity.uuid,
            oRequest = {
                uuid: sUUID,
                activeYN: 'Y',
                deleteYN: 'N',
                statusList: ["9", "10", "11", "12", "33", "34"],
                caseSetAttrFlag: true
            };

        if (this.state.types === "SURVEY") {
            oRequest.types = [this.state.types];
        }
        if (this.state.types === "SERVICES") {
            oRequest.types = ["ALERT"];
        }
        // console.log("oRequest ",oRequest);

        let response = await apiServices.loadAnalysisData(oRequest);
        this.computeMapData(response, sUUID);
    }

    computeMapData = (p_response, sUUID) => {
        // console.log(p_response);
        let aServices = p_response.caseSetTO_Attributes_analysis;
        let tableData = [];
        aServices = aServices.filter(service=> service.latitude!=="" && service.longitude!=="");
        let nLen = aServices.length;

        for (let i = 0; i < nLen; i++) {
            // console.log(aServices[i]);
            let status = "";
            if (aServices[i].status === 9) {
                status = 'Open';
            }
            if (aServices[i].status === 10) {
                status = 'Approved';
            }
            if (aServices[i].status === 11) {
                status = 'Declined';
            }
            if (aServices[i].status === 12) {
                status = 'Resolved';
            }
            let address = (aServices[i].city ? `${aServices[i].city},` : "") + (aServices[i].state ? ` ${aServices[i].state},` : "") + (aServices[i].country ? ` ${aServices[i].country}` : "")
            let date = moment(aServices[i].createdAt).format('DD-MM-YYYY, h:mm:ss a');
            let days = moment(aServices[i].createdAt).format('YYYYMMDD, h:mm:ss a');
            days = moment(days, 'YYYYMMDD, h:mm:ss a').fromNow();
            // console.log("date",days);
            date += (` (${days})`)

            let aTemp = {
                'id': aServices[i].id,
                'services': aServices[i].communityPreferencesByCaseType.name,
                'applicant': aServices[i].applicant.name ? (`${aServices[i].applicant.name} (${aServices[i].applicant.id})`) : (`Anonymous (${aServices[i].applicant.id})`),
                'address': address,
                'status': status,
                'createdAt': date
            };
            tableData.push(aTemp);
        }

        let countryObj = {},
            serviceObj = {};
        for (let i = 0; i < aServices.length; i++) {
            // console.log("aServices[i].communityPreferencesByCaseType",aServices[i].communityPreferencesByCaseType);
            countryObj[aServices[i].country] = 1 + (countryObj[aServices[i].country] || 0);
            serviceObj[aServices[i].communityPreferencesByCaseType.name] = 1 + (serviceObj[aServices[i].communityPreferencesByCaseType.name] || 0);
        }
        // console.log(countryObj);
        // console.log(serviceObj);

        let countryList = Object.keys(countryObj).map(function(key) {
            return { country: key, count: countryObj[key] };
        });

        let serviceList = Object.keys(serviceObj).map(function(key) {
            return { name: key, count: serviceObj[key] };
        });

        // console.log(countryList);
        // console.log(countryList);

        this.setState({ mapData: aServices, tableData, countryList, serviceList, isLoading: false, sUUID, isDataFetched: true });
    }

    onMarkerClick = (data) => {
        // console.log(data)
        this.setState({
            // selectedPlace: props,
            selectedData: data,
            // activeMarker: marker,
            showingInfoWindow: true
        });
    }

    hideMarker = () => {
        this.setState({ showingInfoWindow: false });
    }

    render() {
        // console.log("Your location is::", this.props.latitude, this.props.longitude);
        const columns = [{
            dataField: 'id',
            text: 'ID',
            sort: true,
            headerStyle: () => {
                return { width: "10%" };
            }
        }, {
            dataField: 'services',
            text: this.state.types === "SURVEY" ? 'Survey Name': 'Services Name',
            sort: true
        }, {
            dataField: 'applicant',
            text: 'Applicant',
            sort: true
        }, {
            dataField: 'address',
            text: 'Address',
            sort: true
        }, {
            dataField: 'status',
            text: 'Status',
            sort: true,
            headerStyle: () => {
                return { width: "10%" };
            }
        }, {
            dataField: 'createdAt',
            text: 'Created Date',
            sort: true
        }];

        const columnsCountry = [{
            dataField: 'country',
            text: 'Country',
            sort: true
        }, {
            dataField: 'count',
            text: '# Cases',
            sort: true
        }];

        const columnsService = [{
            dataField: 'name',
            text: 'Service Name',
            sort: true
        }, {
            dataField: 'count',
            text: '# Cases',
            sort: true
        }];

        const defaultSorted = [{
            dataField: 'id',
            order: 'desc'
        }];

        const sizePerPageOptionRenderer = ({
            text,
            page,
            onSizePerPageChange
        }) => (
            <li
                key={ text }
                role="presentation"
                className="dropdown-item"
            >
            { // eslint-disable-next-line
                <a href="javascript:void(0)" 
                    tabIndex="-1"
                    role="menuitem"
                    data-page={ page }
                    onMouseDown={ (e) => {
                        e.preventDefault();
                        onSizePerPageChange(page);
                    } }
                >
                    { text }
                </a>
            }
            </li>
        );

        const paginationOption = {
            page: 1, // which page you want to show as default
            sizePerPageList: [{
                text: '5',
                value: 5
            }, {
                text: '10',
                value: 10
            }, {
                text: 'All',
                value: this.state.tableData.length
            }], // you can change the dropdown list for size per page
            sizePerPage: 5, // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3, // the pagination bar size.
            prePageText: 'Prev', // Previous page button text
            nextPageText: 'Next', // Next page button text
            firstPageText: 'First', // First page button text
            lastPageText: 'Last', // Last page button text
            showTotal: true,
            sizePerPageOptionRenderer
        };

        const paginationOptionStats = {
            page: 1, // which page you want to show as default
            sizePerPageList: [{
                text: '5',
                value: 5
            }], // you can change the dropdown list for size per page
            sizePerPage: 5, // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3, // the pagination bar size.
            prePageText: 'Prev', // Previous page button text
            nextPageText: 'Next', // Next page button text
            firstPageText: 'First', // First page button text
            lastPageText: 'Last', // Last page button text
            showTotal: false,
        };

        console.log(this.state.mapData);

        return (
            <React.Fragment>
                <Loader isLoading={this.state.isLoading}/>
                <Nav tabs className="float-right">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'map' })}
                            onClick={() => { this.toggle('map'); }}
                        >
                            Map View
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'list' })}
                            onClick={() => { this.toggle('list'); }}
                        >
                            List View
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'table' })}
                            onClick={() => { this.toggle('table'); }}
                        >
                            Table View
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'stats' })}
                            onClick={() => { this.toggle('stats'); }}
                        >
                            Stats
                        </NavLink>
                    </NavItem>
                </Nav>
                <div className="clear"></div>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="map" className="mapDetail">
                    { this.state.activeTab === 'map' &&
                        <React.Fragment>
                        {this.state.mapData.length>0 ?
                            <React.Fragment>
                                <MapWithAMarkerClusterer onMarkerClick={this.onMarkerClick} markers={this.state.mapData} latitude={this.props.latitude} longitude={this.props.longitude} />
                           
                                <Modal isOpen={this.state.showingInfoWindow} toggle={this.hideMarker}>
                                    <ModalHeader toggle={this.hideMarker}>Case #{this.state.selectedData.id}</ModalHeader>
                                    <ModalBody>
                                        <Scrollbars style={{ width: '100%', height: 350 }}>
                                            <CaseDetails hideMarker={this.hideMarker} isPopup={true} closeAll={false} showActionButtons="false" discussionBoard="false" caseData={this.state.selectedData} sUUID={this.state.sUUID}/>
                                        </Scrollbars>
                                    </ModalBody>
                                </Modal>
                            </React.Fragment>
                        :
                        <EmptyMap />     
                        }
                        </React.Fragment>
                    }
                    </TabPane>
                    <TabPane tabId="list">
                    {this.state.activeTab === 'list' &&
                        <React.Fragment>
                        {this.state.mapData.length>0 ?
                            <Scrollbars style={{ width: '100%', height: 500 }}>
                            <Accordion defaultActiveKey="0">
                                {this.state.mapData.map((data,index)=>{
                                // console.log(index)
                                let date = moment(data.createdAt).format("MMM Do YYYY, h:mm:ss a");
                                let days = moment(data.createdAt).format("YYYYMMDD, h:mm:ss a");
                                days = moment(days,'YYYYMMDD, h:mm:ss a').fromNow();
                                return  <Card key={index} className="border-bottom">
                                            <Accordion.Toggle as={Card.Header} eventKey={index} className="d-flex justify-content-between cursor_pointer" >
                                                <div>
                                                    <div>
                                                        Case #{data.id}
                                                    </div>
                                                    <div>
                                                        {data.city ? `${data.city},` : ""} {data.state ? `${data.state},` : ""} {data.country ? `${data.country}` : ""}
                                                    </div>
                                                    <div className="text-muted">
                                                        {date} ({days})
                                                    </div>
                                                </div>
                                                <div className="text-right align-self-center">
                                                    {data.status===9 && <Badge className="p-2" variant="dark">Open</Badge>}
                                                    {data.status===10 && <Badge className="p-2" variant="info" >Approved</Badge>}
                                                    {data.status===11 && <Badge className="p-2" variant="danger" >Declined</Badge>}
                                                    {data.status===12 && <Badge className="p-2" variant="success" >Resolved</Badge>}
                                                    <i className="fa fa-angle-right ml-3"></i>
                                                </div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={index}>
                                                <Card.Body>
                                                    <CaseDetails caseData={data} sUUID={this.state.sUUID}/>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>   
                                })}
                            </Accordion>
                            </Scrollbars>
                            : <div className="text-center">{!this.state.isDataFetched ? 'Loading...':'No Data'}</div>
                        }
                        </React.Fragment>
                    }
                    </TabPane>
                    <TabPane tabId="table">
                    { this.state.activeTab === 'table' &&
                        <div className="table_react_bootstrap">
                            <ToolkitProvider
                                keyField="id"
                                data={ this.state.tableData }
                                columns={ columns }
                                exportCSV={ { onlyExportFiltered: true, exportAll: false } }
                                search
                            >
                            {
                                props => (
                                    <div>
                                        <ExportCSVButton { ...props.csvProps }>Export CSV!!</ExportCSVButton>
                                        <SearchBar { ...props.searchProps } />
                                        <BootstrapTable
                                            { ...props.baseProps }
                                            bootstrap4
                                            noDataIndication="No Data"
                                            defaultSorted={ defaultSorted }
                                            pagination={ paginationFactory(paginationOption) } 
                                        />
                                    </div>
                                )
                              }
                            </ToolkitProvider>
                        </div>
                    }
                    </TabPane>
                    <TabPane tabId="stats">
                    {this.state.activeTab === 'stats' &&
                        <Row>
                            <Col>
                                <div className="table_react_bootstrap">
                                    <ToolkitProvider
                                        keyField="country"
                                        data={ this.state.countryList }
                                        columns={ columnsCountry }
                                        search
                                    >
                                    {
                                        props => (
                                            <div>
                                                <h4 className="pb-3 text-center">Country wise cases</h4>
                                                <SearchBar { ...props.searchProps } />
                                                <BootstrapTable
                                                    { ...props.baseProps }
                                                    bootstrap4
                                                    noDataIndication="No Data"
                                                    defaultSorted={ defaultSorted }
                                                    pagination={ paginationFactory(paginationOptionStats) }
                                                />
                                            </div>
                                        )
                                      }
                                    </ToolkitProvider>
                                </div>
                            </Col>
                            <Col>
                                <div className="table_react_bootstrap">
                                    <ToolkitProvider
                                        keyField="name"
                                        data={ this.state.serviceList }
                                        columns={ columnsService }
                                        search
                                    >
                                    {
                                        props => (
                                            <div>
                                                <h4 className="pb-3 text-center">Service wise cases</h4>
                                                <SearchBar { ...props.searchProps } />
                                                <BootstrapTable
                                                    { ...props.baseProps }
                                                    bootstrap4
                                                    noDataIndication="No Data"
                                                    defaultSorted={ defaultSorted }
                                                    pagination={ paginationFactory(paginationOptionStats) }
                                                />
                                            </div>
                                        )
                                      }
                                    </ToolkitProvider>
                                </div>
                            </Col>
                        </Row>
                    }
                    </TabPane>
                </TabContent>
            </React.Fragment>
        )
    }
}

export default MapContainer